import { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { StaffStateCountriesViewContainerBlobCountriesDocument, BlobCountry, StaffStateCountriesEditContainerUpdateBlobCountriesDocument } from '../../../../generated';
import { message } from 'antd';
import { Countries } from './countries';

export const CountriesContainer = () => {
  const [blobData, setBlobData] = useState<any>([]);

  const { data: countryData,
    loading: countryDataLoading,
    error: countryDataError,
  } = useQuery(StaffStateCountriesViewContainerBlobCountriesDocument, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    setBlobData(countryData);
  }, [countryData]);

  const [blobCountriesUpdate, { loading: updateLoading }] = useMutation(StaffStateCountriesEditContainerUpdateBlobCountriesDocument, {
    refetchQueries: [
      {
        query: StaffStateCountriesViewContainerBlobCountriesDocument,
        variables: {
          blobData: {
            countries: []
          }
        }
      },
    ],
    awaitRefetchQueries: true,
  });

  const removeTypename = (obj: { [x: string]: any; __typename: any; }) => {
    const { __typename, ...rest } = obj;
    return rest;
  };

  const handleSave = async (data: any) => {

    const cleanedCountries = data.map((country: any) => {
      const cleanedCountry = removeTypename(country);
      if (Array.isArray(cleanedCountry.states)) {
        cleanedCountry.states = cleanedCountry.states.map((state: any) => removeTypename(state));
      }
      return cleanedCountry;
    });

    try {
      await blobCountriesUpdate({
        variables: {
          input: {
            blobData: {
              apiName: blobData?.blobCountries?.apiName,
              eventPayload: {
                countries: cleanedCountries,
                externalId: blobData?.blobCountries?.eventPayload?.externalId,
              },
              eventTimestamp: blobData?.blobCountries?.eventTimestamp,
              eventUuid: blobData?.blobCountries?.eventUuid,
              replayId: blobData?.blobCountries?.replayId,
            }
          }
        },
      });
      message.success('Countries details updated');
    } catch (error) {
      message.error(`Error Updating Citizenship: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      error={countryDataError}
      hasData={countryData !== undefined}
      hasDataComponent={
        <Countries
          countries={countryData?.blobCountries?.eventPayload?.countries as BlobCountry[]}
          onSave={handleSave}
        />
      } 
      loading={countryDataLoading || updateLoading} />
  );
};
